/**
 * JWT parsing and offline token validation without depending on offlineAuthService
 * or IndexedDB — safe to import from fetchHelper / React Native–compatible entry points.
 */

export function decodeJWT(token: string): any {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export async function validateOfflineToken(token: string): Promise<boolean> {
  try {
    const tokenInfo = decodeJWT(token);
    if (!tokenInfo || !tokenInfo.exp) return false;

    const now = Math.floor(Date.now() / 1000);
    const expirationTime = tokenInfo.exp;

    const { TOKEN_VALIDATION_CONFIG } = await import('./tokenConfig.js');
    return expirationTime > now + TOKEN_VALIDATION_CONFIG.BASIC_VALIDITY_BUFFER;
  } catch {
    return false;
  }
}
